var app = new Vue({
  el: '#custom-lens-product',
  
  data: {
    customLensProducts: window.customLensProducts || []
  },
  
  computed: {
    selected_variants: function() {
      var _this = this;
      var variants = [];
      
      _.each(_this.customLensProducts, function(product) {
        variants = variants.concat(product.selected_variants);
      });
      
      return variants;
    }
  },
  
  mounted: function() {
    var _this = this;
    
    $('.images').slick({
      //setting-name: setting-value
    });    
  },
  
  methods: {
    showProductInfo: function(e, product) {
      var _this = this;
      e.preventDefault();
      
      $.magnificPopup.open({
        items: {
          src: `<div class="white-popup product-description-modal">
                  	<h6 class="text-center">${product.json.title}</h6>
					<div class="product-single__description rte">
						${product.json.description}
					</div>
				</div>`, 
          type: 'inline'
        }
      });      
    },
    
    getCart: function() {
      return $.getJSON('/cart.js');
    },
    
    addItemToCart: function(p_options) {
      var data = {
        quantity: p_options.quantity,
        id: p_options.variant_id,
      };

      if (p_options.properties !== undefined) {
        data['properties'] = p_options.properties
      }
      //console.log(data);

      return new Promise(function(resolve, reject) {
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: data,
          dataType: 'json',
          success: function(data) { 
            resolve(data);
          },
          error: function(error) { 
            reject(error);
          }
        });
      });      
    },
    
    removeItemFromCart: function(p_options) {
      var updates = {};
      updates[p_options.key] = 0;

      //console.log(updates);
      return new Promise(function(resolve, reject) {
        $.post('/cart/update.js', {
          updates: updates, 
          success: function(data) {
            resolve(data);
          }
        });
      });
    },
    
    addItemsToCart: function(e) {
      var _this = this;
      
      var selected_variants = _.map(_this.selected_variants, function(variant) {
        return variant.id;
      });
      
      async.eachSeries(selected_variants, function(item, callback) {
        _this.addItemToCart({
          variant_id: item,
          quantity: 1
        })
        .then(function() {
          callback();
        })
      }, function(err) {
        if (err) {
          console.log(err);
        }

        // After all done
        _this.showCart();
      });
    },
    
    selectVariant: function (e, product) {
      //console.log({e, product});
      e.preventDefault();
      
      var _this = this,
          $target = $(e.currentTarget);
      
      if ($target.is('select')) {
        var variant_id = $target.val();
        if (variant_id == 'none') {
          product.selected_variants = [];
          product.selected_variants_price = '';
        }
        else {
          var matchingVariant = _.filter(product.json.variants, function(v) {
            return v.id == variant_id;
          });
          
          //product.selected_variants.push();
          if (matchingVariant.length) {
            product.selected_variants.push(matchingVariant[0]);
            product.selected_variants_price = matchingVariant[0].price;
          }
        }
      }
      else {
        var selected_variants = [];
        $target.closest('.product-options').find('input[type="checkbox"]').each(function() {
          var $input = $(this);
          var value = $input.val();
          var isChecked = $input.prop('checked');
        
          if (isChecked) {
            var matchingVariant = _.filter(product.json.variants, function(v) {
              return v.title.indexOf(value) !== -1;
            });
            
            var variant_id = matchingVariant[0].id;
            //selected_variants.push(variant_id);
            
            if (matchingVariant.length) {
              selected_variants.push(matchingVariant[0]);
            }
          }
        });
        
        var selected_variants_price = 0
        _.each(selected_variants, function(variant) {
          selected_variants_price += variant.price;
        });
        
        product.selected_variants = selected_variants;
        product.selected_variants_price = selected_variants_price;
      }
    },
    
    showCart: function() {
      window.location.href = '/cart';
    },
    
    formatMoney: function(value) {
      return `${Shopify.formatMoney(value, Shopify.money_format)} ${Shopify.currency.active}`;
    }    
  },
  
  filters: {
    resize: function(src, size) {
      var resized = src;
      resized = resized.replace('.png', `_${size}.png`);
      resized = resized.replace('.jpg', `_${size}.jpg`);
      return resized;
    },
    
    handle: function(value) {
      return value.toLowerCase().replace(' ', '-');
    },
    
    unhandle: function(value) {
      return value.replace('-', ' ');
    }    
  }
});